<template>
    <div id="app">
        <div class="wrapper">
            <navbar/>
            <router-view/>
            <body-footer/>
        </div>
    </div>
</template>

<script>
    import 'bootstrap/dist/css/bootstrap.min.css'
    import 'font-awesome/css/font-awesome.css'
    import './../static/css/style.scss'

    import Navbar from './components/common/Navbar'
    import Footer from './components/common/Footer'
    import headful from 'headful'

    export default {
        name: 'App',
        components: {
            navbar: Navbar,
            bodyFooter: Footer
        },
        methods: {
            set( meta) {


                if (meta) {
                    headful({
                        title: meta.title,
                        description: meta.description
                    })
                }



            },
        },
        mounted() {
            this.set(this.$route.meta)
        },

        watch: {
            /* eslint-disable object-shorthand */
            '$route'(to, from) {
                headful({
                    title: this.$route.meta.title,
                    description: this.$route.meta.description
                })


            },
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue